var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.id ===0)?_c('div',[_c('products')],1):(_vm.id===1)?_c('div',[_c('listen')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }